import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('story-slider', '.story-slider');

loader('navbar', '.header');
loader('menu', '.menu');
loader('faq', '.faq__sidebar');

loader('newsletter', '.newsletter-form');
loader('vacature-filter', '#filter-top');
loader('calendar', '.calendar');
loader('video-block', '.video-locked__frame');
